const namespace = 'PRICE_LEVELS';

export const REQUEST_PRICE_LEVELS = `${namespace}/REQUEST_PRICE_LEVELS`;
export const RECEIVE_PRICE_LEVELS_SUCCESS = `${namespace}/RECEIVE_PRICE_LEVELS_SUCCESS`;
export const RECEIVE_PRICE_LEVELS_FAILURE = `${namespace}/RECEIVE_PRICE_LEVELS_FAILURE`;